// extracted by mini-css-extract-plugin
module.exports = {"header":"CollapsibleHeader_header__2vrlB","title":"CollapsibleHeader_title__2M4ha","toggle":"CollapsibleHeader_toggle__2-EiG"};